import { Input, PageHeader } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { PlatformRoleEnum, SiteRoleEnum } from 'domains/roleDomain';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AccountItemForm from './AccountItemForm';
import { AccountTable } from './AccountTable';

const { Search } = Input;

const AccountAdmin = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.account.curItem);

  const [searchValue, setSearchValue] = useState<string>('');
  const onSearch = (value: string) => {
    setSearchValue(value);
    dispatch.account.setSearchEmail(value || '');
  };

  return (
    <>
      <PageHeader
        ghost={false}
        title={t('platform.header.userAccounts')}
        className="platform-page-header"
        extra={[
          <Search
            key="search"
            placeholder="Search email"
            onSearch={onSearch}
            allowClear
            enterButton
            style={{ width: 200 }}
          />,
          <RevxButton
            key="create"
            disabled={!!curItem}
            brandGreen
            onClick={() => {
              dispatch.account.setState({
                curItem: {
                  siteRole: SiteRoleEnum.NoSiteAccess,
                  platformRole: PlatformRoleEnum.NoAdminAccess,
                },
              });
            }}
          >
            {t('platform.account.createUserAccount')}
          </RevxButton>,
        ]}
      />
      {curItem && <AccountItemForm />}
      <AccountTable searchValue={searchValue} />
    </>
  );
};

export default AccountAdmin;
